export const injectKendoLegacyStyles = () => {
  const link = document.createElement("link");

  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "/dist/css/combined-kendo.css?v=638816372920000000";

  document.head.appendChild(link);
};
